import request from './request'

export const getProductList = (params) => {
  return request({
    url: '/admin/products',
    method: 'get',
    params
  })
}

export const getProductDetail = (id) => {
  return request({
    url: `/admin/products/${id}`,
    method: 'get'
  })
}

export const createProduct = (data) => {
  return request({
    url: '/admin/products',
    method: 'post',
    data
  })
}

export const updateProduct = (id, data) => {
  return request({
    url: `/admin/products/${id}`,
    method: 'put',
    data
  })
}

export const deleteProduct = (id) => {
  return request({
    url: `/admin/products/${id}`,
    method: 'delete'
  })
}

// SKU 相关接口
export const getSkuList = (productId) => {
  return request({
    url: `/admin/products/${productId}/skus`,
    method: 'get'
  })
}

export const getSkuDetail = (productId, skuId) => {
  return request({
    url: `/admin/products/${productId}/skus/${skuId}`,
    method: 'get'
  })
}

export const createSku = (productId, data) => {
  return request({
    url: `/admin/products/${productId}/skus`,
    method: 'post',
    data
  })
}

export const updateSku = (productId, skuId, data) => {
  return request({
    url: `/admin/products/${productId}/skus/${skuId}`,
    method: 'put',
    data
  })
}

export const deleteSku = (productId, skuId) => {
  return request({
    url: `/admin/products/${productId}/skus/${skuId}`,
    method: 'delete'
  })
}